import { hyphenateHTMLSync } from "hyphen/pl";

export const hyphenateWord = (text, minLen = 6) =>
  hyphenateHTMLSync(text, {
    minWordLength: minLen,
  });
